// @ts-check
// Relações que apontam para um objeto genérico mas significam algo específico: a escola de origem é uma
// organização do tipo escola. O seletor mostra o nome específico e o "Criar" já preenche o tipo.
import { objectsById } from '../data/metadata-store.js';
import { t } from '../i18n/index.js';

/** @type {Record<string, { labelKey: string, prefill: Record<string, unknown> }>} */
const RELATION_PRESETS = {
  'person.originSchool': { labelKey: 'recordPicker.presets.school', prefill: { organizationType: 'SCHOOL' } },
};

/**
 * @param {import('./field-metadata.js').FieldMetadata} field
 * @returns {{ objectLabel: string, prefill: Record<string, unknown> } | null}
 */
export function getRelationPreset(field) {
  const objectName = objectsById.value.get(field.objectMetadataId)?.nameSingular;
  const preset = objectName ? RELATION_PRESETS[`${objectName}.${field.name}`] : undefined;
  return preset ? { objectLabel: t(preset.labelKey), prefill: preset.prefill } : null;
}
